import { Chakra } from "@airhelp/react-ui-components";

const { createIcon } = Chakra;

const CheckmarkIcon = createIcon({
  displayName: "CheckmarkIcon",
  viewBox: "0 0 18 14",
  path: (
    <path
      fill="currentColor"
      d="M15.995.931c-.2598.0073-.5064.1081-.6875.2812l-10.293 9.5592-3.293-3.0582a1.005 1.005 0 00-.3246-.2093 1.0659 1.0659 0 00-.3866-.0762 1.0677 1.0677 0 00-.3882.0689 1.009 1.009 0 00-.3292.203.927.927 0 00-.2187.3058A.8711.8711 0 000 8.3659a.8727.8727 0 00.082.359.931.931 0 00.2254.3015l4 3.7149c.1875.1741.4418.2719.707.2719.2652 0 .5195-.0978.707-.2719l11-10.2158c.1445-.1305.2432-.2984.2832-.4819a.8684.8684 0 00-.0592-.5461c-.0786-.1724-.2114-.3187-.381-.4198a1.058 1.058 0 00-.5695-.1466z"
    />
  ),
});

const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M5.446 4L4 5.446 10.554 12 4 18.554 5.446 20 12 13.446 18.554 20 20 18.554 13.446 12 20 5.446 18.554 4 12 10.554z"
    />
  ),
});

const InfoIcon = createIcon({
  displayName: "InfoIcon",
  viewBox: "0 0 14 14",
  path: (
    <path
      fill="currentColor"
      d="M7.00016 0.000366211C3.32616 0.000366211 0.333496 2.99303 0.333496 6.66703C0.333496 10.341 3.32616 13.3337 7.00016 13.3337C10.6742 13.3337 13.6668 10.341 13.6668 6.66703C13.6668 2.99303 10.6742 0.000366211 7.00016 0.000366211ZM7.00016 1.3337C9.95358 1.3337 12.3335 3.71362 12.3335 6.66703C12.3335 9.62045 9.95358 12.0004 7.00016 12.0004C4.04675 12.0004 1.66683 9.62045 1.66683 6.66703C1.66683 3.71362 4.04675 1.3337 7.00016 1.3337ZM6.3335 3.3337V4.66703H7.66683V3.3337H6.3335ZM6.3335 6.00037V10.0004H7.66683V6.00037H6.3335Z"
    />
  ),
});

const ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 18 14",
  path: (
    <path
      fill="currentColor"
      d="M11 0C10.7441 0 10.488 0.0994218 10.293 0.294922L10.207 0.380859C9.81603 0.771859 9.81603 1.40492 10.207 1.79492L14.0703 5.6582H1C0.448 5.6582 0 6.1062 0 6.6582C0 7.2102 0.448 7.6582 1 7.6582H14.0703L10.207 11.5215C9.81603 11.9125 9.81603 12.5455 10.207 12.9355L10.293 13.0215C10.684 13.4125 11.317 13.4125 11.707 13.0215L17.3633 7.36523C17.7543 6.97423 17.7543 6.34117 17.3633 5.95117L11.707 0.294922C11.5115 0.0994218 11.2559 0 11 0Z"
    />
  ),
});

const ArrowRightAltIcon = createIcon({
  displayName: "ArrowRightAltIcon",
  viewBox: "0 0 21 20",
  path: (
    <>
      <path
        d="M11.4429 9.69292L8.25875 6.50875C7.91375 6.16375 7.91375 5.60375 8.25875 5.25875C8.60375 4.91375 9.16375 4.91375 9.50875 5.25875L13.3538 9.10375C13.6796 9.42958 13.6796 9.95708 13.3538 10.2821L9.50875 14.1271C9.16375 14.4721 8.60375 14.4721 8.25875 14.1271C7.91375 13.7821 7.91375 13.2221 8.25875 12.8771L11.4429 9.69292Z"
        fill="currentColor"
      />
    </>
  ),
});

const ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  viewBox: "0 0 24 24",
  path: <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />,
});

const ChevronLefttIcon = createIcon({
  displayName: "ChevronLefttIcon",
  viewBox: "0 0 24 24",
  path: <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />,
});

const MoneyIcon = createIcon({
  displayName: "MoneyIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      fill="currentColor"
      d="m10 0c-5.52 0-10 4.48013-10 10.0003 0 5.5202 4.48 10.0003 10 10.0003s10-4.4801 10-10.0003c0-5.52017-4.48-10.0003-10-10.0003zm2.2457 15.8685c-.4736.1664-.8357.5853-.8357 1.0872 0 .5771-.4678 1.0448-1.0448 1.0448h-.55969c-.58846 0-1.06551-.477-1.06551-1.0655 0-.5038-.35847-.9268-.82906-1.1069-1.01985-.3903-1.85934-1.0907-2.23518-2.1273-.19507-.5381.27614-1.0304.84846-1.0304.51357 0 .90929.4166 1.17125.8583.35939.6061 1.0974 1.0117 2.38453 1.0117 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.6101-2.67-2.1401-2.48-.6-4.18-1.62003-4.18-3.67009 0-1.43404.96617-2.45101 2.28423-2.96399.46886-.18248.82577-.60539.82577-1.10851 0-.58964.47801-1.06765 1.06765-1.06765h.51105c.6027 0 1.0913.48859 1.0913 1.0913 0 .50386.3535.92666.8101 1.13967.969.45202 1.5866 1.21994 1.8671 2.10569.1682.53143-.291 1.0035-.8484 1.0035-.5252 0-.917-.43711-1.1489-.90826-.2932-.59546-.913-.9618-2.0099-.9618-1.5 0-2.4.68002-2.4 1.64005 0 .84003.65 1.39004 2.67 1.91006s4.18 1.39003 4.18 3.91013c-.0083 1.5246-.9606 2.4731-2.2843 2.9381z"
    />
  ),
});

const PlaneIcon = createIcon({
  displayName: "PlaneIcon",
  viewBox: "0 0 48 48",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.183 10.0012C12.9644 10.0078 12.7427 10.0406 12.5278 10.1042C10.9705 10.5667 10.2563 12.3279 11.0643 13.7083L19.276 27.7272L6.80309 30.9475L3.16835 27.9565C2.67127 27.5467 1.99685 27.4116 1.37489 27.5961C0.179943 27.946 -0.366416 29.3033 0.26534 30.3577L3.42182 35.6283C4.53352 37.4832 6.76762 38.3887 8.89306 37.8422L44.9487 28.5463C44.9535 28.5447 44.9583 28.5432 44.9631 28.5416C46.7186 28.2395 47.9991 26.7475 48 25.003C48 23.0176 46.3555 21.4081 44.327 21.4081C44.0073 21.4082 43.6889 21.4491 43.38 21.5298V21.5252L30.5724 24.8251L14.9813 10.6612C14.4872 10.2118 13.8389 9.9814 13.183 10.0012Z"
    />
  ),
});

const CheckmarkThickIcon = createIcon({
  displayName: "CheckmarkThickIcon",
  viewBox: "0 0 48 48",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 4C12.954 4 4 12.954 4 24C4 35.046 12.954 44 24 44C35.046 44 44 35.046 44 24C44 12.954 35.046 4 24 4ZM35.414 19.414L21.414 33.414C21.024 33.804 20.512 34 20 34C19.488 34 18.976 33.804 18.586 33.414L12.586 27.414C11.804 26.632 11.804 25.368 12.586 24.586C13.368 23.804 14.632 23.804 15.414 24.586L20 29.172L32.586 16.586C33.368 15.804 34.632 15.804 35.414 16.586C36.196 17.368 36.196 18.632 35.414 19.414Z"
    />
  ),
});

const XThickIcon = createIcon({
  displayName: "XThickIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        d="M0 12C0 5.3835 5.3835 0 12 0C18.6165 0 24 5.3835 24 12C24 18.6165 18.6165 24 12 24C5.3835 24 0 18.6165 0 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83729 7.00036C7.49819 7.00045 7.19295 7.20599 7.06535 7.52017C6.93775 7.83435 7.01323 8.19452 7.25624 8.43103L10.8337 12.0085L7.25624 15.586C7.03854 15.795 6.95084 16.1054 7.02697 16.3974C7.10311 16.6894 7.33117 16.9175 7.6232 16.9936C7.91523 17.0698 8.22561 16.9821 8.43462 16.7644L12.0121 13.1869L15.5896 16.7644C15.7986 16.9821 16.109 17.0698 16.401 16.9936C16.693 16.9175 16.9211 16.6894 16.9972 16.3974C17.0733 16.1054 16.9857 15.795 16.768 15.586L13.1905 12.0085L16.768 8.43103C17.0144 8.19145 17.0885 7.82514 16.9546 7.5086C16.8206 7.19206 16.5061 6.99023 16.1625 7.00036C15.946 7.00682 15.7405 7.0973 15.5896 7.25264L12.0121 10.8301L8.43462 7.25264C8.27773 7.09137 8.06229 7.00038 7.83729 7.00036Z"
        fill="white"
      />
    </g>
  ),
});

const ConsultantIcon = createIcon({
  displayName: "ConsultantIcon",
  viewBox: "0 0 19 20",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.15909 0.00635547C8.87474 -0.00525103 8.58706 -0.000738326 8.29581 0.0180742C4.28069 0.278698 1.1941 3.61067 0.862217 7.56886L0.848545 7.55128L0.00674846 17.8384C-0.0882515 19.0034 0.831889 20.0005 2.00089 20.0005H10.829C11.381 20.0005 11.829 19.5525 11.829 19.0005C11.829 18.4485 11.381 18.0005 10.829 18.0005H8.82901C5.51501 18.0005 2.82901 15.3145 2.82901 12.0005V11.0005C2.82901 9.8955 3.72401 9.0005 4.82901 9.0005H12.829C13.934 9.0005 14.829 9.8955 14.829 11.0005V14.0005H10.7411C10.5295 13.4019 9.96392 13.0014 9.32901 13.0005C8.93119 13.0005 8.54966 13.1585 8.26835 13.4398C7.98705 13.7211 7.82901 14.1027 7.82901 14.5005C7.83007 15.2865 8.43764 15.9384 9.22159 15.9946C9.25727 15.9985 9.29313 16.0005 9.32901 16.0005H15.829H16.829C17.929 16.0005 18.829 15.1005 18.829 14.0005V12.0005C18.829 10.9005 17.929 10.0005 16.829 10.0005V8.0005C16.829 3.69268 13.4243 0.180452 9.15909 0.00635547Z"
    />
  ),
});

const BadgeCheckmarkIcon = createIcon({
  displayName: "BadgeCheckmarkIcon",
  viewBox: "0 0 18 22",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.188 0.1725L1.188 3.2835C0.465 3.6045 0 4.3205 0 5.1115V9.8115C0 17.6415 6.439 21.2975 9 21.8115C11.561 21.2975 18 17.6415 18 9.8115V5.1115C18 4.3215 17.535 3.6045 16.812 3.2835L9.812 0.1725C9.295 -0.0575 8.705 -0.0575 8.188 0.1725ZM7.293 14.5185L4.523 11.7485C4.133 11.3585 4.133 10.7245 4.523 10.3345C4.913 9.9445 5.547 9.9445 5.937 10.3345L8 12.3975L13.085 7.3125C13.475 6.9225 14.109 6.9225 14.499 7.3125C14.889 7.7025 14.889 8.3365 14.499 8.7265L8.707 14.5185C8.317 14.9085 7.683 14.9085 7.293 14.5185Z"
    />
  ),
});

const SofaIcon = createIcon({
  displayName: "SofaIcon",
  viewBox: "0 0 24 18",
  path: (
    <>
      <path
        fill="currentColor"
        d="M9.00017 9.74997V10.5H15.0002V9.74997C15.0002 6.85542 17.3549 4.49999 20.2502 4.49999C20.4325 4.49999 20.6154 4.51693 20.7982 4.5357C20.1401 1.93676 17.8007 0 15.0002 0H9.00017C6.19966 0 3.8602 1.93681 3.20215 4.5357C3.38491 4.51693 3.5678 4.49999 3.75019 4.49999C6.64543 4.49999 9.00017 6.85542 9.00017 9.74997Z"
      />
      <path
        fill="currentColor"
        d="M23.849 8.67566C23.5046 7.44869 22.4921 6.45332 21.2589 6.13162C18.7531 5.47782 16.4999 7.35072 16.4999 9.75005V12H7.50001V9.75C7.50001 7.35067 5.2469 5.47782 2.74108 6.13157C1.50788 6.45327 0.495386 7.44864 0.150976 8.67562C-0.207809 9.95378 0.0990606 11.1553 0.794519 12.0409C1.22893 12.5943 1.5 13.2557 1.5 13.9592V16.5H4.49998V18H7.49996V16.5H16.4999V18H19.4999V16.5H22.4999V13.9592C22.4999 13.2558 22.771 12.5943 23.2054 12.0409C23.9009 11.1553 24.2078 9.95382 23.849 8.67566ZM3.74995 10.5C3.33577 10.5 2.99997 10.1642 2.99997 9.75005C2.99997 9.33578 3.33577 9.00007 3.74995 9.00007C4.16413 9.00007 4.49994 9.33578 4.49994 9.75005C4.49994 10.1642 4.16413 10.5 3.74995 10.5ZM20.25 10.5C19.8358 10.5 19.5 10.1642 19.5 9.75005C19.5 9.33578 19.8358 9.00007 20.25 9.00007C20.6641 9.00007 20.9999 9.33578 20.9999 9.75005C20.9999 10.1642 20.6641 10.5 20.25 10.5Z"
      />
    </>
  ),
});

const DoctorIcon = createIcon({
  displayName: "DoctorIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      fill="currentColor"
      d="M2 0C1.466 0 0.962937 0.207938 0.585938 0.585938C0.207938 0.963938 0 1.467 0 2V5C0 7.94204 1.83005 10.4544 4.4082 11.4863C4.76204 12.1019 5.32167 12.5754 6 12.8164V16C6 18.209 7.791 20 10 20H14C16.209 20 18 18.209 18 16V15.8262C18.5845 15.6195 19.0907 15.2368 19.4488 14.7307C19.807 14.2246 19.9995 13.62 20 13C20 12.2044 19.6839 11.4413 19.1213 10.8787C18.5587 10.3161 17.7956 10 17 10C16.2044 10 15.4413 10.3161 14.8787 10.8787C14.3161 11.4413 14 12.2044 14 13C14.0009 13.6197 14.1936 14.2239 14.5517 14.7296C14.9098 15.2353 15.4158 15.6177 16 15.8242V16C16 17.105 15.105 18 14 18H10C8.895 18 8 17.105 8 16V12.8164C8.67833 12.5754 9.23796 12.1019 9.5918 11.4863C12.17 10.4535 14 7.93699 14 4.97656V2C14 0.895 13.105 0 12 0H11C10.448 0 10 0.448 10 1C10 1.552 10.448 2 11 2H12V4.77734C12 7.38634 10.099 9.72161 7.50195 9.97461C7.31564 9.99286 7.12947 10.0018 6.94727 10C4.21415 9.97229 2.00102 7.73844 2.00195 4.97656L2 2H3C3.552 2 4 1.552 4 1C4 0.448 3.552 0 3 0H2Z"
    />
  ),
});

const TrustPilotLogoIcon = createIcon({
  displayName: "TrustPilotLogoIcon",
  viewBox: "0 0 15 14",
  path: (
    <path
      fill="currentColor"
      d="M8.74006 5.09709H14.1526L9.79308 8.25613L7.09735 10.1937L2.71679 13.3527L4.38056 8.25613L0 5.09709H5.41252L7.07629 0.000488281L8.74006 5.09709ZM10.151 9.43213L7.07617 10.2109L11.4357 13.3892L10.151 9.43213Z"
    />
  ),
});

const GavelIcon = createIcon({
  displayName: "GavelIcon",
  viewBox: "0 0 42 38",
  path: (
    <path
      fill="currentColor"
      d="M23.2849 0.000875059C22.7653 0.0163573 22.2721 0.233516 21.9099 0.606344L19.9099 2.60634L11.6052 10.9071C11.6018 10.9105 11.6007 10.9154 11.5974 10.9188L9.6052 12.911C9.08273 13.4127 8.87227 14.1576 9.05499 14.8584C9.23771 15.5593 9.78504 16.1067 10.4859 16.2894C11.1868 16.4721 11.9317 16.2616 12.4333 15.7392L13.0232 15.1493L16.8513 18.9774L1.58567 34.2431C1.06319 34.7447 0.852727 35.4896 1.03544 36.1905C1.21816 36.8914 1.7655 37.4387 2.46638 37.6214C3.16726 37.8041 3.91216 37.5937 4.41379 37.0712L19.6794 21.8056L23.8513 25.9774L23.2654 26.5634C22.7429 27.065 22.5324 27.8099 22.7151 28.5108C22.8979 29.2117 23.4452 29.759 24.1461 29.9417C24.847 30.1244 25.5918 29.914 26.0935 29.3915L28.0896 27.3915L36.3943 19.0907L39.07 16.4149C39.6616 15.84 39.8394 14.9608 39.5179 14.2011C39.1964 13.4414 38.4415 12.957 37.6169 12.9813C37.0973 12.9968 36.6042 13.214 36.2419 13.5868L34.9802 14.8485L24.1521 4.02041L24.738 3.43447C25.3295 2.85949 25.5074 1.98034 25.1859 1.22064C24.8644 0.460949 24.1095 -0.0234427 23.2849 0.000875059ZM25.0307 34.0007C24.3094 33.9905 23.6385 34.3694 23.2749 34.9924C22.9113 35.6154 22.9113 36.3859 23.2749 37.0089C23.6385 37.6319 24.3094 38.0109 25.0307 38.0007H39.0073C39.7285 38.0109 40.3994 37.6319 40.763 37.0089C41.1267 36.3859 41.1267 35.6154 40.763 34.9924C40.3994 34.3694 39.7285 33.9905 39.0073 34.0007H25.0307Z"
    />
  ),
});

const EarthWithPlaneIcon = createIcon({
  displayName: "EarthWithPlaneIcon",
  viewBox: "0 0 40 40",
  path: (
    <path
      fill="currentColor"
      d="M15.9493 2.33137e-07C15.4246 0.000250233 14.9001 0.201563 14.5001 0.601563L11.6017 3.5L3.44932 1.14844L2.0001 2.60156L7.2501 7.85156L5.3751 9.72656L1.47276 8.42578L0.000100673 9.89844L8.09385 18L9.57041 16.5234L8.27354 12.625L10.1485 10.75L15.3946 15.9961L16.8478 14.5469L14.5001 6.39844L17.3985 3.5C18.1985 2.7 18.1985 1.40356 17.3985 0.601563C16.9975 0.200563 16.4741 -0.000249767 15.9493 2.33137e-07ZM23.8479 0.460256C22.8431 0.514295 22.0348 1.30638 21.9605 2.30988C21.8862 3.31339 22.569 4.21586 23.5549 4.41729C25.1409 4.77796 26.6312 5.38438 28.0002 6.1751V13.9993C28.0002 15.0993 28.9002 15.9993 30.0002 15.9993C31.1042 15.9993 32.0002 16.8953 32.0002 17.9993C32.0002 19.1033 31.1042 19.9993 30.0002 19.9993H24.0002C22.9002 19.9993 22.0002 20.8993 22.0002 21.9993V25.9993C22.0002 28.1993 23.8002 29.9993 26.0002 29.9993C27.1042 29.9993 28.0002 30.8953 28.0002 31.9993V33.8548C25.6474 35.2124 22.9215 35.9993 20.0002 35.9993C18.6148 35.9993 17.2807 35.8042 16.0002 35.4759V33.9993C16.0002 31.7993 14.2002 29.9993 12.0002 29.9993C10.8962 29.9993 10.0002 29.1033 10.0002 27.9993V25.9993C10.0002 24.8993 9.1002 23.9993 8.0002 23.9993H4.52364C4.19535 22.7188 4.0002 21.3847 4.0002 19.9993C4.0104 19.278 3.63145 18.6072 3.00846 18.2435C2.38546 17.8799 1.61494 17.8799 0.991947 18.2435C0.368951 18.6072 -0.00999971 19.278 0.000200864 19.9993C0.000200864 31.022 8.97753 39.9993 20.0002 39.9993C31.0229 39.9993 40.0002 31.022 40.0002 19.9993C40.0002 10.503 33.3503 2.53997 24.4455 0.514944C24.3149 0.483375 24.1814 0.465053 24.0471 0.460256C23.9807 0.456947 23.9142 0.456947 23.8479 0.460256Z"
    />
  ),
});

const BanknotesIcon = createIcon({
  displayName: "BanknotesIcon",
  viewBox: "0 0 40 36",
  path: (
    <path
      fill="currentColor"
      d="M35.25 0.0213339C34.9928 -0.0164473 34.7245 -0.00519734 34.457 0.0643027L3.98047 8.0018H19.8555L31.7695 4.90024C32.2755 5.64424 33.0864 6.12302 33.9844 6.20102L34.457 8.0018H38.5898L36.8945 1.4979C36.686 0.696896 36.0216 0.134678 35.25 0.0213339ZM2 12.0009C0.895476 12.001 0.000110436 12.8964 0 14.0009V34.0009C0.000110436 35.1054 0.895476 36.0008 2 36.0009H38C39.1045 36.0008 39.9999 35.1054 40 34.0009V14.0009C39.9999 12.8964 39.1045 12.001 38 12.0009H2ZM5.82422 16.0009H34.1758C34.478 16.8527 35.1482 17.5229 36 17.8251V30.1767C35.1482 30.4789 34.478 31.1491 34.1758 32.0009H5.82422C5.522 31.1491 4.85183 30.4789 4 30.1767V17.8251C4.85183 17.5229 5.522 16.8527 5.82422 16.0009ZM20 18.0009C16.6863 18.0009 14 20.6872 14 24.0009C14 27.3146 16.6863 30.0009 20 30.0009C23.3137 30.0009 26 27.3146 26 24.0009C26 20.6872 23.3137 18.0009 20 18.0009ZM10 22.0009C8.896 22.0009 8 22.8949 8 24.0009C8 25.1069 8.896 26.0009 10 26.0009C11.104 26.0009 12 25.1069 12 24.0009C12 22.8949 11.104 22.0009 10 22.0009ZM30 22.0009C28.896 22.0009 28 22.8949 28 24.0009C28 25.1069 28.896 26.0009 30 26.0009C31.104 26.0009 32 25.1069 32 24.0009C32 22.8949 31.104 22.0009 30 22.0009Z"
    />
  ),
});

const LuggageIcon = createIcon({
  displayName: "LuggageIcon",
  viewBox: "0 0 40 36",
  path: (
    <path
      fill="currentColor"
      d="M12 4C12 1.79 13.79 0 16 0H24C26.21 0 28 1.79 28 4V6V8C28 9.104 28.896 10 30 10C31.104 10 32 9.104 32 8V6H36C38.21 6 40 7.79 40 10V32C40 34.21 38.21 36 36 36H4C1.79 36 0 34.21 0 32V10C0 7.79 1.79 6 4 6H8V8C8 9.104 8.896 10 10 10C11.104 10 12 9.104 12 8V6V4ZM24 3.99999H16V5.99999H24V3.99999ZM25 16C26.656 16 28 17.344 28 19C28 20.656 26.656 22 25 22C23.344 22 22 20.656 22 19C22 17.344 23.344 16 25 16ZM34.1757 22.5537C33.9912 22.1832 33.6074 21.9785 33.2187 22.0029C33.0891 22.011 32.9594 22.043 32.8359 22.1045L23.2812 27.1357C22.7852 27.3817 22.5801 27.9855 22.8281 28.4795L23.9375 30.6904C24.1855 31.1824 24.7833 31.3836 25.2773 31.1396L34.832 26.1084C35.328 25.8624 35.5292 25.2586 35.2812 24.7646L34.1757 22.5537Z"
    />
  ),
});

const FacebookIcon = createIcon({
  displayName: "FacebookIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M16.403 9H14V7c0-1.032.084-1.682 1.563-1.682h.868a1 1 0 001-1V3.064c0-.523-.401-.97-.923-1.005A26.154 26.154 0 0014.693 2C11.98 2 10 3.657 10 6.699V9H8a1 1 0 00-1 1v2a1 1 0 001 1l2-.001V21a1 1 0 001 1h2a1 1 0 001-1v-8.003l2.174-.001a1 1 0 00.993-.886l.229-1.996A1 1 0 0016.403 9z"
    />
  ),
});

const InstagramIcon = createIcon({
  displayName: "InstagramIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M8 3a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V8a5 5 0 00-5-5H8zm10 2a1 1 0 110 2 1 1 0 010-2zm-6 2a5 5 0 11-.001 10.001A5 5 0 0112 7zm0 2a3 3 0 100 6 3 3 0 000-6z"
    />
  ),
});

const TwitterIcon = createIcon({
  displayName: "TwitterIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M21.634 4.032c-.815.385-2.202 1.107-2.899 1.245-.027.007-.049.016-.075.023A4.485 4.485 0 0015.5 4 4.502 4.502 0 0011 8.5c0 .132-.01.373 0 .5-3.218 0-5.568-1.678-7.327-3.836-.235-.29-.485-.14-.537.067-.117.466-.157 1.245-.157 1.8 0 1.402 1.095 2.778 2.8 3.63-.314.082-.66.14-1.02.14a2.97 2.97 0 01-1.339-.335c-.158-.083-.499-.06-.398.344.405 1.619 2.253 2.756 3.904 3.087-.375.22-1.175.176-1.543.176-.136 0-.609-.032-.915-.07-.279-.034-.708.038-.349.582.771 1.167 2.515 1.9 4.016 1.928-1.382 1.084-3.642 1.48-5.807 1.48-.438-.01-.416.489-.063.674C3.862 19.505 6.478 20 8.347 20 15.777 20 20 14.338 20 9l-.005-.447c0-.018.005-.035.005-.053 0-.027-.008-.053-.008-.08a18.838 18.838 0 00-.009-.33c.59-.424 1.491-1.162 1.947-1.727.155-.192.03-.425-.18-.352-.544.189-1.483.555-2.07.625 1.176-.78 1.758-1.457 2.258-2.21.171-.257-.043-.518-.304-.394z"
    />
  ),
});

const LinkedInIcon = createIcon({
  displayName: "LinkedInIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M7.025 20H3.107V8.86h3.918V20zM4.997 6.82C3.8 6.82 3 6 3 4.91 3 3.818 3.798 3 5.129 3c1.197 0 1.997.818 1.997 1.91 0 1.091-.798 1.91-2.13 1.91zM21 20h-3.792v-6.088c0-1.684-1.01-2.072-1.39-2.072-.379 0-1.643.26-1.643 2.072V20h-3.917V8.86h3.917v1.556c.505-.908 1.516-1.555 3.412-1.555S21 10.416 21 13.91V20z"
    />
  ),
});

const CaretIcon = createIcon({
  displayName: "CaretIcon",
  viewBox: "0 0 12 7",
  path: (
    <path
      fill="currentColor"
      d="m5.6315 4.1315-3.821-3.821c-.414-.414-1.086-.414-1.5 0s-.414 1.086 0 1.5l4.614 4.614c.391.391 1.024.391 1.414 0l4.614-4.614c.414-.414.414-1.086 0-1.5s-1.086-.414-1.5 0z"
    />
  ),
});

const PlaneUpIcon = createIcon({
  displayName: "PlaneUpIcon",
  viewBox: "0 0 20 12",
  path: (
    <path
      fill="currentColor"
      d="M5.38375 0.000489806C5.29447 0.00323981 5.20392 0.0169585 5.11617 0.0434585C4.48017 0.236459 4.18852 0.971365 4.51852 1.54736L7.87203 7.39697L2.77828 8.74072L1.29391 7.49268C1.09091 7.32168 0.815486 7.26529 0.561486 7.34229C0.073486 7.48829 -0.149639 8.05463 0.108361 8.49463L1.39742 10.6938C1.85142 11.4678 2.7638 11.8457 3.6318 11.6177L18.3564 7.73877C18.3584 7.73812 18.3603 7.73747 18.3623 7.73682C19.0792 7.61076 19.6021 6.98817 19.6025 6.26026C19.6025 5.43183 18.9309 4.76026 18.1025 4.76026C17.9719 4.76028 17.8419 4.77735 17.7158 4.81104V4.80908L12.4853 6.18604L6.11813 0.27588C5.91638 0.0883804 5.6516 -0.00776019 5.38375 0.000489806Z"
    />
  ),
});

const PlaneDownIcon = createIcon({
  displayName: "PlaneUpIcon",
  viewBox: "0 0 18 14",
  path: (
    <path
      fill="currentColor"
      d="M8.09961 5.90276e-05C7.50596 0.00610193 7 0.491621 7 1.11725V7.74615L2.08398 6.45123L1.39648 4.59967C1.31148 4.37267 1.11786 4.2025 0.880859 4.1485C0.430859 4.0455 0 4.38862 0 4.85162V7.46295C0 8.36995 0.611281 9.16454 1.48828 9.39654L16.1484 13.2833V13.2794C16.2635 13.3075 16.3815 13.3219 16.5 13.3223C17.3284 13.3223 18 12.6508 18 11.8223C17.9998 11.1032 17.4894 10.4854 16.7832 10.3497L11.7891 9.01373L9.17773 0.779356C9.05773 0.401356 8.74638 0.114403 8.35938 0.0274027C8.27225 0.00777773 8.18442 -0.000804272 8.09961 5.90276e-05Z"
    />
  ),
});

const HamburgerMenuIcon = createIcon({
  displayName: "HamburgerMenuIcon",
  viewBox: "0 0 24 13",
  path: (
    <>
      <rect width="24" height="3" rx="1.5" fill="currentColor" />
      <rect y="10" width="24" height="3" rx="1.5" fill="currentColor" />
    </>
  ),
});

const TrustPilotStarIcon = createIcon({
  displayName: "TrustPilotStarIcon",
  viewBox: "0 0 25 24",
  path: (
    <path
      d="M24.6187 8.97923H15.2177L12.3139 0L9.40103 8.97923L0 8.97012L7.61339 14.5252L4.70052 23.4953L12.3139 17.9493L19.9182 23.4953L17.0144 14.5252L24.6187 8.97923Z"
      fill="currentColor"
    />
  ),
});

const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 48 48",
  path: (
    <>
      <path
        fill="currentColor"
        d="M24 4C12.972 4 4 12.972 4 24C4 35.028 12.972 44 24 44C24.45 44 24.89 43.962 25.332 43.932C24.756 42.704 24.356 41.382 24.156 39.992C24.152 39.992 24.15 39.992 24.146 39.992C24.052 39.342 24 38.678 24 38C24 30.268 30.268 24 38 24C38.678 24 39.342 24.052 39.992 24.148C39.992 24.152 39.992 24.154 39.992 24.158C41.382 24.356 42.706 24.756 43.932 25.334C43.962 24.89 44 24.45 44 24C44 12.972 35.028 4 24 4ZM25.414 25.414L18.828 32C18.048 32.78 16.78 32.78 16 32C15.22 31.22 15.22 29.952 16 29.172L22 23.172V14C22 12.896 22.896 12 24 12C25.104 12 26 12.896 26 14V24C26 24.53 25.79 25.038 25.414 25.414Z"
      />
      <path
        fill="currentColor"
        d="M38 28C32.478 28 28 32.478 28 38C28 43.522 32.478 48 38 48C43.522 48 48 43.522 48 38C48 32.478 43.522 28 38 28ZM42 40H34C32.896 40 32 39.104 32 38C32 36.896 32.896 36 34 36H42C43.104 36 44 36.896 44 38C44 39.104 43.104 40 42 40Z"
      />
    </>
  ),
});

const CrossedPlaneIcon = createIcon({
  displayName: "CrossedPlaneIcon",
  viewBox: "0 0 48 48",
  path: (
    <>
      <path
        fill="currentColor"
        d="M18.86 20H10C10 20 10 20 7.24003 16.604C6.95003 16.248 6.67803 16 6.22003 16H5.00003C4.35003 16 3.87203 16.612 4.03003 17.242L6.00003 24L4.03003 30.758C3.87203 31.388 4.35003 32 5.00003 32H6.22003C6.67803 32 6.95003 31.752 7.24003 31.396C10 28 10 28 10 28H20.98L16.086 41.288C15.668 42.634 16.674 44 18.084 44C18.804 44 19.474 43.628 19.858 43.018L28.782 29.96L18.86 20ZM40 20H30L19.898 4.982C19.516 4.372 18.846 4 18.124 4C16.716 4 15.71 5.366 16.128 6.712L19.4 14.92L32.48 28H40C42.22 28 44 26.2 44 24C44 21.8 42.22 20 40 20Z"
      />
      <path
        fill="currentColor"
        d="M38 39.1721L8.82795 10.0001C8.04795 9.21807 6.78195 9.21807 5.99995 10.0001C5.21795 10.7821 5.21795 12.0481 5.99995 12.8281L35.172 42.0001C35.954 42.7821 37.2199 42.7821 38 42.0001C38.7799 41.2181 38.782 39.9521 38 39.1721Z"
      />
    </>
  ),
});

const XIcon = createIcon({
  displayName: "XIcon",
  viewBox: "0 0 48 48",
  path: (
    <path
      fill="currentColor"
      d="M20 0C8.94 0 0 8.94 0 20C0 31.06 8.94 40 20 40C31.06 40 40 31.06 40 20C40 8.94 31.06 0 20 0ZM29.414 26.586C30.196 27.368 30.196 28.632 29.414 29.414C29.024 29.804 28.512 30 28 30C27.488 30 26.976 29.804 26.586 29.414L20 22.828L13.414 29.414C13.024 29.804 12.512 30 12 30C11.488 30 10.976 29.804 10.586 29.414C9.804 28.632 9.804 27.368 10.586 26.586L17.172 20L10.586 13.414C9.804 12.632 9.804 11.368 10.586 10.586C11.368 9.804 12.632 9.804 13.414 10.586L20 17.172L26.586 10.586C27.368 9.804 28.632 9.804 29.414 10.586C30.196 11.368 30.196 12.632 29.414 13.414L22.828 20L29.414 26.586Z"
    />
  ),
});

const PeopleIcon = createIcon({
  displayName: "PeopleIcon",
  viewBox: "0 0 36 48",
  path: (
    <path
      fill="currentColor"
      d="M18 0C16.9391 0 15.9217 0.421427 15.1716 1.17157C14.4214 1.92172 14 2.93913 14 4C14 5.06087 14.4214 6.07828 15.1716 6.82843C15.9217 7.57857 16.9391 8 18 8C19.0609 8 20.0783 7.57857 20.8284 6.82843C21.5786 6.07828 22 5.06087 22 4C22 2.93913 21.5786 1.92172 20.8284 1.17157C20.0783 0.421427 19.0609 0 18 0ZM20 10H16C12.686 10 10 12.686 10 16V32H12V38C12 39.104 12.896 40 14 40C15.104 40 16 39.104 16 38V32H20V38C20 39.104 20.896 40 22 40C23.104 40 24 39.104 24 38V32H26V16C26 12.686 23.314 10 20 10ZM8 0C6.93913 0 5.92172 0.421427 5.17157 1.17157C4.42143 1.92172 4 2.93913 4 4C4 5.06087 4.42143 6.07828 5.17157 6.82843C5.92172 7.57857 6.93913 8 8 8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0ZM28 0C26.9391 0 25.9217 0.421427 25.1716 1.17157C24.4214 1.92172 24 2.93913 24 4C24 5.06087 24.4214 6.07828 25.1716 6.82843C25.9217 7.57857 26.9391 8 28 8C29.0609 8 30.0783 7.57857 30.8284 6.82843C31.5786 6.07828 32 5.06087 32 4C32 2.93913 31.5786 1.92172 30.8284 1.17157C30.0783 0.421427 29.0609 0 28 0ZM0 14C0 14 0 24 0 26C0 28 2 28 2 28V38C2 39.104 2.896 40 4 40C5.104 40 6 39.104 6 38C6 38 6 28 6 26C6 24 4 24 4 24C4 24 4 16 4 15C4 14 5 14 5 14H6.202C6.506 12.514 7.166 11.168 8.05 10H4C1.79 10 0 11.79 0 14ZM32 10H27.95C28.834 11.168 29.496 12.514 29.798 14H31C31 14 32 14 32 15C32 16 32 24 32 24C32 24 30 24 30 26C30 28 30 38 30 38C30 39.104 30.896 40 32 40C33.104 40 34 39.104 34 38V28C34 28 36 28 36 26C36 24 36 14 36 14C36 11.79 34.21 10 32 10Z"
    />
  ),
});

const EnvelopeIcon = createIcon({
  displayName: "EnvelopeIcon",
  viewBox: "0 0 20 16",
  path: (
    <path
      d="M18 -0.000488273L2 -0.00048828C0.895 -0.000488281 -3.91039e-10 0.894512 -8.73831e-10 1.99951L-6.11682e-09 13.9995C-6.59961e-09 15.1045 0.895 15.9995 2 15.9995L18 15.9995C19.105 15.9995 20 15.1045 20 13.9995L20 1.99951C20 0.894512 19.105 -0.000488273 18 -0.000488273ZM17.601 4.24851L10.53 8.66851C10.206 8.87151 9.794 8.87151 9.47 8.66851L2.399 4.24851C2.151 4.09351 2 3.82151 2 3.52951C2 2.86351 2.733 2.45751 3.297 2.81051L10 6.99951L16.703 2.81051C17.267 2.45751 18 2.86351 18 3.52951C18 3.82151 17.849 4.09351 17.601 4.24851Z"
      fill="currentColor"
    />
  ),
});

const CopyIcon = createIcon({
  displayName: "CopyIcon",
  viewBox: "0 0 20 20",
  path: (
    <path
      d="M2 8.73831e-10C0.895 3.91039e-10 -3.91039e-10 0.895 -8.73831e-10 2L-6.55373e-09 15C-6.79491e-09 15.552 0.448 16 1 16C1.552 16 2 15.552 2 15L2 2L15 2C15.552 2 16 1.552 16 1C16 0.448 15.552 6.79514e-09 15 6.55396e-09L2 8.73831e-10ZM6 4C4.895 4 4 4.895 4 6L4 18C4 19.105 4.895 20 6 20L18 20C19.105 20 20 19.105 20 18L20 6C20 4.895 19.105 4 18 4L6 4ZM6 6L18 6L18 18L6 18L6 6Z"
      fill="currentColor"
    />
  ),
});

const NumberOneIcon = createIcon({
  displayName: "NumberOneIcon",
  viewBox: "0 0 46 46",
  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM17.8885 18.376L23.0005 14.68H25.5205V31H22.2805V18.64L19.4725 20.584L17.8885 18.376Z"
      fill="currentColor"
    />
  ),
});

const NumberTwoIcon = createIcon({
  displayName: "NumberTwoIcon",
  viewBox: "0 0 47 46",

  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM24.673 24.6894C24.3277 24.8898 23.9736 25.0952 23.6153 25.312C23.3693 25.4625 23.1262 25.6057 22.8894 25.7452C21.5785 26.5173 20.4642 27.1736 20.1593 28.312H28.9913V31H16.7753V29.728C16.7753 26.164 19.1576 24.7075 21.4605 23.2995L21.6233 23.2C22.0246 22.955 22.4155 22.7316 22.7872 22.5191C24.5274 21.5243 25.8473 20.7699 25.8473 19.168C25.8473 17.848 24.8153 17.032 23.4233 17.032C21.8633 17.032 20.6873 17.944 19.1993 19.816L16.8233 18.136C18.4793 15.712 20.4473 14.272 23.3513 14.272C27.1433 14.272 29.0633 16.576 29.0633 19.12C29.0633 22.1425 27.0808 23.2926 24.673 24.6894Z"
      fill="currentColor"
    />
  ),
});

const NumberThreeIcon = createIcon({
  displayName: "NumberThreeIcon",
  viewBox: "0 0 47 46",
  path: (
    <path
      d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46ZM28.3388 17.32L23.8748 21.112C26.8028 21.232 28.9628 23.032 28.9628 25.984C28.9628 28.648 26.8748 31.408 22.8188 31.408C20.6348 31.408 18.8588 30.88 16.5308 29.296L18.0908 27.016C19.9388 28.144 21.1868 28.648 22.7228 28.648C24.6188 28.648 25.7228 27.592 25.7228 26.008C25.7228 24.376 24.4028 23.44 22.5548 23.44C21.5228 23.44 20.9228 23.632 20.6108 23.752L19.1948 21.808L24.4268 17.368H17.3708V14.68H28.3388V17.32Z"
      fill="currentColor"
    />
  ),
});

const PlusIcon = createIcon({
  displayName: "PlusIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      d="M15 7H9V1C9 0.448 8.552 0 8 0C7.448 0 7 0.448 7 1V7H1C0.448 7 0 7.448 0 8C0 8.552 0.448 9 1 9H7V15C7 15.552 7.448 16 8 16C8.552 16 9 15.552 9 15V9H15C15.552 9 16 8.552 16 8C16 7.448 15.552 7 15 7Z"
      fill="currentColor"
    />
  ),
});

const MinusIcon = createIcon({
  displayName: "MinusIcon",
  viewBox: "0 0 16 2",
  path: <rect width="16" height="2" rx="1" fill="currentColor" />,
});

const DownloadIcon = createIcon({
  displayName: "DownloadIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M11.014 2a1 1 0 00-1 1v8h-3.5a.5.5 0 00-.322.883l5.105 4.814.034.032a1 1 0 001.367 0l.013-.012.01-.012 5.104-4.812a.505.505 0 00.03-.028l.007-.006.006-.005a.5.5 0 00-.354-.854h-3.5V3a1 1 0 00-1-1h-2zm-8 18a1 1 0 100 2h18a1 1 0 100-2h-18z"
      fill="currentColor"
    />
  ),
});

const SideMenuIcon = createIcon({
  displayName: "SideMenuIcon",
  viewBox: "0 0 32 20",

  path: (
    <>
      <path
        d="M6.90002 7.49999C6.90002 6.89248 7.39251 6.39999 8.00002 6.39999H24C24.6075 6.39999 25.1 6.89248 25.1 7.49999C25.1 8.10751 24.6075 8.59999 24 8.59999H8.00002C7.39251 8.59999 6.90002 8.10751 6.90002 7.49999Z"
        fill="currentColor"
      />
      <path
        d="M8.00002 11.4C7.39251 11.4 6.90002 11.8925 6.90002 12.5C6.90002 13.1075 7.39251 13.6 8.00002 13.6H19C19.6075 13.6 20.1 13.1075 20.1 12.5C20.1 11.8925 19.6075 11.4 19 11.4H8.00002Z"
        fill="currentColor"
      />
      <path
        d="M0.900024 1.49999C0.900024 0.892481 1.39251 0.399994 2.00002 0.399994H30C30.6075 0.399994 31.1 0.892481 31.1 1.49999V18.5C31.1 19.1075 30.6075 19.6 30 19.6H2.00002C1.39251 19.6 0.900024 19.1075 0.900024 18.5V1.49999ZM3.10002 2.59999V17.4H28.9V2.59999H3.10002Z"
        fill="currentColor"
      />
    </>
  ),
});

const LinkIcon = createIcon({
  displayName: "LinkIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.9558 11.38C4.2358 9.91 5.6158 8.9 7.1158 8.9H10.0458C10.5658 8.9 10.9958 8.47 10.9958 7.95C10.9958 7.43 10.5658 7 10.0458 7H7.2158C4.6058 7 2.2758 8.91 2.0258 11.51C1.7358 14.49 4.0758 17 6.9958 17H10.0458C10.5658 17 10.9958 16.57 10.9958 16.05C10.9958 15.53 10.5658 15.1 10.0458 15.1H6.9958C5.0858 15.1 3.5758 13.36 3.9558 11.38ZM8.9958 13H14.9958C15.5458 13 15.9958 12.55 15.9958 12C15.9958 11.45 15.5458 11 14.9958 11H8.9958C8.4458 11 7.9958 11.45 7.9958 12C7.9958 12.55 8.4458 13 8.9958 13ZM13.9458 7H16.7758C19.3858 7 21.7258 8.91 21.9758 11.51C22.2558 14.49 19.9158 17 16.9958 17H13.9458C13.4258 17 12.9958 16.57 12.9958 16.05C12.9958 15.53 13.4258 15.1 13.9458 15.1H16.9958C18.9058 15.1 20.4158 13.36 20.0358 11.38C19.7558 9.91 18.3758 8.9 16.8758 8.9H13.9458C13.4258 8.9 12.9958 8.47 12.9958 7.95C12.9958 7.43 13.4258 7 13.9458 7Z"
      fill="currentColor"
    />
  ),
});

const HammerIcon = createIcon({
  displayName: "HammerIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1427 2.99995C12.8829 3.00769 12.6363 3.11627 12.4552 3.30268L11.4552 4.30268L7.30284 8.45307C7.30116 8.45476 7.30061 8.45723 7.29894 8.45893L6.30284 9.45503C6.04161 9.70585 5.93638 10.0783 6.02774 10.4287C6.1191 10.7792 6.39277 11.0528 6.7432 11.1442C7.09364 11.2356 7.46609 11.1303 7.71691 10.8691L8.01183 10.5742L9.92589 12.4882L2.29308 20.121C2.03184 20.3719 1.92661 20.7443 2.01797 21.0947C2.10932 21.4452 2.38299 21.7189 2.73343 21.8102C3.08387 21.9016 3.45632 21.7963 3.70714 21.5351L11.34 13.9023L13.4259 15.9882L13.1329 16.2812C12.8717 16.532 12.7665 16.9045 12.8578 17.2549C12.9492 17.6053 13.2228 17.879 13.5733 17.9704C13.9237 18.0617 14.2962 17.9565 14.547 17.6953L15.545 16.6953L19.6974 12.5449L21.0353 11.207C21.331 10.9195 21.42 10.4799 21.2592 10.1001C21.0984 9.72022 20.721 9.47803 20.3087 9.49018C20.0489 9.49792 19.8023 9.6065 19.6212 9.79292L18.9903 10.4238L13.5763 5.00971L13.8693 4.71675C14.165 4.42925 14.2539 3.98968 14.0932 3.60983C13.9324 3.22999 13.555 2.98779 13.1427 2.99995ZM14.0157 20C13.6551 19.9949 13.3197 20.1843 13.1378 20.4958C12.956 20.8073 12.956 21.1926 13.1378 21.5041C13.3197 21.8156 13.6551 22.005 14.0157 21.9999H21.004C21.3647 22.005 21.7001 21.8156 21.8819 21.5041C22.0637 21.1926 22.0637 20.8073 21.8819 20.4958C21.7001 20.1843 21.3647 19.9949 21.004 20H14.0157Z"
      fill="currentColor"
    />
  ),
});

const BlueInfoIcon = createIcon({
  displayName: "BlueInfoIcon",
  viewBox: "0 0 33 33",
  path: (
    <path
      d="M16.75 0.0266113C7.928 0.0266113 0.75 7.20461 0.75 16.0266C0.75 24.8486 7.928 32.0266 16.75 32.0266C25.572 32.0266 32.75 24.8486 32.75 16.0266C32.75 7.20461 25.572 0.0266113 16.75 0.0266113ZM18.75 7.02661C19.855 7.02661 20.75 7.92161 20.75 9.02661C20.75 10.1316 19.855 11.0266 18.75 11.0266C17.645 11.0266 16.75 10.1316 16.75 9.02661C16.75 7.92161 17.645 7.02661 18.75 7.02661ZM20.513 24.0726C18.694 24.7886 18.163 25.0266 16.995 25.0266C16.041 25.0266 15.299 24.7936 14.77 24.3286C13.725 23.4086 13.901 22.0806 14.228 20.7206L15.212 17.2376C15.402 16.5206 15.787 15.0556 15.248 14.5416C14.709 14.0276 13.454 14.3526 12.724 14.6246L12.987 13.5516C14.041 13.1226 15.373 12.5976 16.51 12.5976C18.22 12.5976 19.471 13.4526 19.471 15.0666C19.471 15.2176 19.453 15.4836 19.418 15.8656C19.352 16.5666 19.332 16.5206 18.24 20.3866C18.118 20.8116 17.929 21.7146 17.929 22.1516C17.929 23.8346 19.886 23.4186 20.776 22.9986L20.513 24.0726Z"
      fill="currentColor"
    />
  ),
});

const CircleIcon = createIcon({
  displayName: "CircleIcon",
  viewBox: "0 0 8 9",
  path: <circle cx="2" cy="4.36011" r="2" fill="currentColor" />,
});

const GraphIcon = createIcon({
  displayName: "GraphIcon",
  viewBox: "0 0 45 41",
  path: (
    <>
      <path
        d="M31.6665 40.6453H25.6665C25.4013 40.6453 25.1469 40.5399 24.9594 40.3524C24.7719 40.1648 24.6665 39.9105 24.6665 39.6453V29.6453C24.6665 29.38 24.7719 29.1257 24.9594 28.9382C25.1469 28.7506 25.4013 28.6453 25.6665 28.6453H31.6665C31.9317 28.6453 32.1861 28.7506 32.3736 28.9382C32.5611 29.1257 32.6665 29.38 32.6665 29.6453V39.6453C32.6665 39.9105 32.5611 40.1648 32.3736 40.3524C32.1861 40.5399 31.9317 40.6453 31.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M15.1955 7.53021C14.6485 7.14119 14.1705 6.66324 13.7815 6.11621L6.68151 13.2112C6.07281 12.8451 5.3768 12.6496 4.66651 12.6452C3.87538 12.6452 3.10202 12.8798 2.44422 13.3193C1.78643 13.7589 1.27374 14.3836 0.970988 15.1145C0.668237 15.8454 0.589024 16.6496 0.743365 17.4256C0.897705 18.2015 1.27867 18.9142 1.83808 19.4736C2.39749 20.033 3.11022 20.414 3.88614 20.5684C4.66207 20.7227 5.46633 20.6435 6.19724 20.3407C6.92814 20.038 7.55286 19.5253 7.99238 18.8675C8.43191 18.2097 8.66651 17.4363 8.66651 16.6452C8.66301 15.9332 8.46747 15.2354 8.10051 14.6252L15.1955 7.53021Z"
        fill="currentColor"
      />
      <path
        d="M16.6665 8.64526C18.8756 8.64526 20.6665 6.8544 20.6665 4.64526C20.6665 2.43612 18.8756 0.645264 16.6665 0.645264C14.4574 0.645264 12.6665 2.43612 12.6665 4.64526C12.6665 6.8544 14.4574 8.64526 16.6665 8.64526Z"
        fill="currentColor"
      />
      <path
        d="M40.6665 8.64526C42.8756 8.64526 44.6665 6.8544 44.6665 4.64526C44.6665 2.43612 42.8756 0.645264 40.6665 0.645264C38.4574 0.645264 36.6665 2.43612 36.6665 4.64526C36.6665 6.8544 38.4574 8.64526 40.6665 8.64526Z"
        fill="currentColor"
      />
      <path
        d="M39.1957 7.53021C38.6487 7.14119 38.1707 6.66324 37.7817 6.11621L30.6867 13.2112C30.0779 12.8411 29.3792 12.6453 28.6667 12.6453C27.9542 12.6453 27.2555 12.8411 26.6467 13.2112L19.5517 6.11621C19.1627 6.66324 18.6847 7.14119 18.1377 7.53021L25.2327 14.6302C24.8666 15.2389 24.6711 15.9349 24.6667 16.6452C24.6667 17.7061 25.0881 18.7235 25.8383 19.4736C26.5884 20.2238 27.6058 20.6452 28.6667 20.6452C29.7276 20.6452 30.745 20.2238 31.4951 19.4736C32.2453 18.7235 32.6667 17.7061 32.6667 16.6452C32.6632 15.9332 32.4677 15.2354 32.1007 14.6252L39.1957 7.53021Z"
        fill="currentColor"
      />
      <path
        d="M7.6665 40.6453H1.6665C1.40129 40.6453 1.14693 40.5399 0.959397 40.3524C0.771861 40.1648 0.666504 39.9105 0.666504 39.6453V29.6453C0.666504 29.38 0.771861 29.1257 0.959397 28.9382C1.14693 28.7506 1.40129 28.6453 1.6665 28.6453H7.6665C7.93172 28.6453 8.18607 28.7506 8.37361 28.9382C8.56115 29.1257 8.6665 29.38 8.6665 29.6453V39.6453C8.6665 39.9105 8.56115 40.1648 8.37361 40.3524C8.18607 40.5399 7.93172 40.6453 7.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M19.6665 40.6453H13.6665C13.4013 40.6453 13.1469 40.5399 12.9594 40.3524C12.7719 40.1648 12.6665 39.9105 12.6665 39.6453V17.6453C12.6665 17.38 12.7719 17.1257 12.9594 16.9382C13.1469 16.7506 13.4013 16.6453 13.6665 16.6453H19.6665C19.9317 16.6453 20.1861 16.7506 20.3736 16.9382C20.5611 17.1257 20.6665 17.38 20.6665 17.6453V39.6453C20.6665 39.9105 20.5611 40.1648 20.3736 40.3524C20.1861 40.5399 19.9317 40.6453 19.6665 40.6453Z"
        fill="currentColor"
      />
      <path
        d="M43.6665 40.6453H37.6665C37.4013 40.6453 37.1469 40.5399 36.9594 40.3524C36.7719 40.1648 36.6665 39.9105 36.6665 39.6453V17.6453C36.6665 17.38 36.7719 17.1257 36.9594 16.9382C37.1469 16.7506 37.4013 16.6453 37.6665 16.6453H43.6665C43.9317 16.6453 44.1861 16.7506 44.3736 16.9382C44.5611 17.1257 44.6665 17.38 44.6665 17.6453V39.6453C44.6665 39.9105 44.5611 40.1648 44.3736 40.3524C44.1861 40.5399 43.9317 40.6453 43.6665 40.6453Z"
        fill="currentColor"
      />
    </>
  ),
});

const TableSortUpIcon = createIcon({
  displayName: "TableSortUpIcon",
  viewBox: "0 0 9 10",
  path: (
    <path
      d="M3.63971 0.374423C3.83641 0.170006 4.16359 0.170006 4.36029 0.374423L7.5154 3.65331C7.82106 3.97096 7.59594 4.5 7.15511 4.5H0.844887C0.404057 4.5 0.178938 3.97096 0.484598 3.65331L3.63971 0.374423Z"
      fill="currentColor"
    />
  ),
});

const TableSortDownIcon = createIcon({
  displayName: "TableSortDownIcon",
  viewBox: "0 0 9 10",
  path: (
    <path
      d="M4.36029 4.62558C4.16359 4.82999 3.83641 4.82999 3.63971 4.62558L0.484598 1.34669C0.178938 1.02904 0.404056 0.5 0.844886 0.5L7.15511 0.5C7.59594 0.5 7.82106 1.02904 7.5154 1.34669L4.36029 4.62558Z"
      fill="currentColor"
    />
  ),
});

const SearchIcon = createIcon({
  displayName: "SearchIcon",
  viewBox: "0 0 18 18",
  path: (
    <path
      d="M6.50008 0.666656C3.28829 0.666656 0.666748 3.2882 0.666748 6.49999C0.666748 9.71178 3.28829 12.3333 6.50008 12.3333C7.95675 12.3333 9.28759 11.79 10.3119 10.901L10.6667 11.2558V12.3333L15.3217 16.9883C15.7817 17.4483 16.5284 17.4483 16.9884 16.9883C17.4484 16.5283 17.4484 15.7816 16.9884 15.3216L12.3334 10.6667H11.2559L10.9011 10.3118C11.7901 9.2875 12.3334 7.95666 12.3334 6.49999C12.3334 3.2882 9.71187 0.666656 6.50008 0.666656ZM6.50008 2.33332C8.81114 2.33332 10.6667 4.18893 10.6667 6.49999C10.6667 8.81105 8.81114 10.6667 6.50008 10.6667C4.18902 10.6667 2.33341 8.81105 2.33341 6.49999C2.33341 4.18893 4.18902 2.33332 6.50008 2.33332Z"
      fill="currentColor"
    />
  ),
});

const PlaneWithClockIcon = createIcon({
  displayName: "PlaneWithClockIcon",
  viewBox: "0 0 40 38",
  path: (
    <path
      d="m27.675 17.066-5.3572-3.3475v-9.99906c0-.98646-.3919-1.93251-1.0894-2.63004-.6975-.697533-1.6436-1.0894-2.6301-1.0894-.9864 0-1.9325.391867-2.63 1.0894-.6975.69753-1.0894 1.64358-1.0894 2.63004v10.00036l-13.964064 8.7208c-.401056.2502-.697185.638-.8329493 1.0907-.1357647.4528-.1018585.9395.0953723 1.3691.19723.4296.544263.7725.976131.9647.43187.1921.91897.2203 1.37011.0792l12.3554-3.8484v9.9644l-3.0909 2.3116c-.2897.2166-.4956.5268-.5826.8779-.087.3512-.0498.7216.1053 1.0484s.4185.5899.7455.7445c.327.1547.6975.1914 1.0485.1039l5.4936-1.3743 3.3351.8338c-1.9798-2.1927-3.0746-5.0426-3.0722-7.9968-.0031-5.5073 3.7386-10.1572 8.8138-11.5433zm3.8342 2.3946c-.2262-.0167-.4537-.0254-.6818-.0254-1.5025-.0004-2.982.3682-4.3087 1.0735-1.3266.7052-2.4598 1.7255-3.2999 2.9711-.8401 1.2457-1.3614 2.6786-1.5181 4.1728-.1568 1.4943.0558 3.0042.6192 4.3971l.0055.0142c.717 1.7525 1.9555 3.2421 3.5477 4.2668 1.4764.9513 3.1961 1.4561 4.9524 1.4537 5.0602 0 9.1745-4.1156 9.1745-9.1746.0006-4.8297-3.7491-8.7983-8.4908-9.1492zm-.6832 15.267c-1.2089-.0005-2.3905-.3593-3.3956-1.0311-1.0055-.672-1.7891-1.6271-2.2518-2.7444-.4627-1.1174-.5837-2.3468-.3478-3.533.236-1.1861.8183-2.2756 1.6734-3.1308s1.9446-1.4377 3.1307-1.6738c1.1861-.236 2.4155-.1151 3.5329.3475s2.0725 1.2461 2.7447 2.2515c.6721 1.0054 1.031 2.1875 1.0314 3.3969-.0016 1.6221-.6468 3.1773-1.7939 4.3242-1.147 1.1467-2.7021 1.7916-4.324 1.793zm2.1566-8.4425-1.1307 2.1163 1.3124 1.3105c.16.1605.2689.3647.313.587s.0214.4527-.0653.662c-.0867.2094-.2334.3885-.4217.5146-.1882.1261-.4097.1936-.6363.1941-.0623-.0004-.1245-.0057-.1859-.0161-.2374-.0379-.4566-.1502-.6262-.3205l-1.9137-1.9106c-.1741-.1736-.2877-.3986-.3239-.6418-.0363-.2431.0066-.4915.1225-.7083l1.4878-2.7853.044-.0818c.1436-.2674.3871-.4672.6774-.5558.2903-.0887.6039-.0589.8724.0828.2434.1309.4316.3451.5301.6034.0984.2583.1006.5434.0061.8032-.0172.0501-.0379.099-.062.1463z"
      fill="currentColor"
    />
  ),
});

const WorldIcon = createIcon({
  displayName: "WorldIcon",
  viewBox: "0 0 41 40",
  path: (
    <path
      d="m24.6666 0c-6.3125 0-11.9062 3.89063-14.4375 9.375-5.60935 2.4922-9.562474 8.1094-9.562474 14.625 0 8.8125 7.187504 16 15.999974 16 6.5157 0 12.1328-3.9531 14.625-9.5625 5.4375-2.5078 9.375-7.9687 9.375-14.4375 0-8.89062-7.3125-16-16-16zm0 4c3.1328 0 6.0235 1.22656 8.1875 3.25-.1015.24219-.1875.47656-.1875.75 0 1.10156.8985 2 2 2 .1172 0 .2032-.04687.3125-.0625.75 1.2656 1.2578 2.6719 1.5 4.1875-.2578-.0703-.539-.125-.8125-.125-1.6562 0-3 1.3438-3 3s1.3438 3 3 3c.1016 0 .211.0078.3125 0-.6953 1.8828-1.8984 3.5078-3.375 4.8125.0157-.2734.0625-.5391.0625-.8125 0-4.5-1.8672-8.5859-4.875-11.5.5469-.6875.875-1.5547.875-2.5 0-2.21094-1.789-4-4-4-1.7265 0-3.1875 1.09375-3.75 2.625-1.3593-.375-2.7734-.625-4.25-.625-.2734 0-.539.04688-.8125.0625 2.211-2.4375 5.3907-4.0625 8.8125-4.0625zm-8 8c6.6485 0 12 5.3516 12 12 0 1.2656-.2031 2.4766-.5625 3.625-.0078.0234-.0547.0391-.0625.0625-.0234.0391-.0468.0859-.0625.125-.2812.3516-.4375.7969-.4375 1.25-1.8984 4.1094-6.0312 6.9375-10.875 6.9375-3.6797 0-6.92966-1.6641-9.12497-4.25.64843-.3281 1.125-.9688 1.125-1.75 0-1.1016-.89844-2-2-2-.4375 0-.79688.2031-1.125.4375-.54688-1.375-.875-2.8672-.875-4.4375 0-4.8438 2.82812-8.9766 6.93747-10.875.0157-.0078.0469.0078.0625 0 .4844 0 .9532-.1797 1.3125-.5 1.1641-.375 2.3907-.625 3.6875-.625zm-4 4c-2.2109 0-3.99997 1.7891-3.99997 4s1.78907 4 3.99997 4c2.211 0 4-1.7891 4-4s-1.789-4-4-4zm8 0c-1.1015 0-2 .8984-2 2s.8985 2 2 2c1.1016 0 2-.8984 2-2s-.8984-2-2-2zm2 9c-1.6562 0-3 1.3438-3 3s1.3438 3 3 3c1.6563 0 3-1.3438 3-3s-1.3437-3-3-3zm-6 5c-1.1015 0-2 .8984-2 2s.8985 2 2 2c1.1016 0 2-.8984 2-2s-.8984-2-2-2z"
      fill="currentColor"
    />
  ),
});

const FoodIcon = createIcon({
  displayName: "FoodIcon",
  viewBox: "0 0 39 38",
  path: (
    <path
      d="m22.3333 0c-1.1 0-2 .9-2 2 0 .66.3403 1.19812.8203 1.57812-.86 1.7-1.8785 4.08266-2.3985 6.72268 1.84.38 3.5963 1.1573 5.1563 2.2773 4.08 2.92 6.4219 7.8019 6.4219 13.4219 0 4.78-2.2413 9.08-5.7813 12h9.7813c2.2 0 4-1.8 4-4v-20c0-4.02-1.5604-7.94187-2.8204-10.42188.48-.38.8204-.91812.8204-1.57812 0-1.1-.9-2-2-2zm-12.0743 7.97656c-.74135.0219-1.40975.45225-1.73653 1.11809s-.25828 1.45785.17797 2.05765c.53249.7553 1.03795 1.7414 1.34376 2.8789-1.81248.1185-3.55803.7344-5.06251 1.8243-2.954 2.138-4.648438 5.8288-4.648438 10.1328 0 6.622 5.831998 12.0117 13.000048 12.0117 7.168 0 13-5.3897 13-12.0117 0-4.3-1.7301-8.0041-4.7461-10.1641-2.1749-1.5563-4.8077-2.1188-7.4102-1.6484-.3582-2.2313-1.3071-4.0462-2.2109-5.32814-.3839-.5618-1.0269-.88997-1.7071-.8711z"
      fill="currentColor"
    />
  ),
});

const CalendarIcon = createIcon({
  displayName: "CalendarIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M7 2C6.448 2 6 2.448 6 3V4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.448 17.552 2 17 2C16.448 2 16 2.448 16 3V4H8V3C8 2.448 7.552 2 7 2ZM5 9H19V19C19 19.552 18.552 20 18 20H6C5.448 20 5 19.552 5 19V9Z"
      fill="currentColor"
    />
  ),
});

const CancelledFlightIcon = createIcon({
  displayName: "CancelledFlightIcon",
  viewBox: "0 0 48 48",
  path: (
    <path
      d="M27.4754 35.0311L29.1115 36.6672L27.4754 38.3026C26.9376 38.8407 26.5273 39.4926 26.2748 40.2103C26.0223 40.928 25.9341 41.6932 26.0165 42.4495L25.9859 42.4415L20.0824 43.9184C19.7052 44.0124 19.3071 43.9729 18.9556 43.8067C18.6042 43.6405 18.3212 43.3578 18.1545 43.0066C17.9879 42.6554 17.9479 42.2574 18.0414 41.88C18.1349 41.5027 18.3561 41.1694 18.6674 40.9366L21.9889 38.4525V27.7446L8.71166 31.8802C8.22686 32.0318 7.70342 32.0015 7.23933 31.795C6.77523 31.5885 6.40231 31.22 6.19036 30.7584C5.97842 30.2967 5.94198 29.7737 6.08787 29.2871C6.23377 28.8006 6.55199 28.3839 6.98297 28.115L21.9889 18.7435V7.99697C21.9889 6.93691 22.41 5.92026 23.1596 5.17068C23.9092 4.42111 24.9258 4 25.9859 4C27.0459 4 28.0626 4.42111 28.8122 5.17068C29.5617 5.92026 29.9829 6.93691 29.9829 7.99697V18.7435L42.2116 26.3823C41.9918 26.3536 41.7704 26.3389 41.5487 26.3384C40.8798 26.3365 40.2171 26.4674 39.599 26.7234C38.981 26.9795 38.4199 27.3555 37.9481 27.8299L36.3127 29.466L34.6766 27.8299C34.205 27.3518 33.6434 26.9717 33.0242 26.7116C32.405 26.4514 31.7405 26.3163 31.0689 26.314C30.3973 26.3117 29.7318 26.4423 29.1109 26.6983C28.49 26.9543 27.9258 27.3305 27.4509 27.8054C26.976 28.2803 26.5998 28.8445 26.3438 29.4654C26.0878 30.0863 25.9572 30.7518 25.9595 31.4234C25.9618 32.095 26.0969 32.7595 26.3571 33.3787C26.6172 33.9979 26.9973 34.5594 27.4754 35.0311ZM39.2743 36.6674L43.0294 40.4226L43.0301 40.422C43.4155 40.8162 43.6299 41.3466 43.6268 41.8979C43.6236 42.4493 43.4032 42.9771 43.0134 43.367C42.6235 43.7569 42.0956 43.9773 41.5443 43.9804C40.993 43.9835 40.4626 43.7691 40.0683 43.3837L36.3132 39.6279L33.9536 41.9874L32.5547 43.3864C32.3604 43.5812 32.1296 43.7357 31.8755 43.841C31.6213 43.9462 31.3489 44.0003 31.0738 43.9999C30.7987 44.0002 30.5263 43.9462 30.2722 43.8409C30.018 43.7356 29.7872 43.5812 29.5929 43.3864L29.5443 43.3344C29.1732 42.9379 28.9708 42.4127 28.9799 41.8697C28.989 41.3267 29.2088 40.8085 29.5929 40.4246L30.886 39.1323L33.3508 36.6674L29.9826 33.2993L29.5949 32.9116C29.2095 32.5173 28.9951 31.987 28.9983 31.4356C29.0014 30.8843 29.2218 30.3564 29.6117 29.9665C30.0015 29.5767 30.5294 29.3563 31.0807 29.3531C31.6321 29.35 32.1624 29.5644 32.5567 29.9498L36.3125 33.7056L39.3529 30.6646L40.0677 29.9498C40.2613 29.7517 40.4924 29.5939 40.7474 29.4857C41.0025 29.3775 41.2765 29.321 41.5535 29.3194C41.8305 29.3179 42.1051 29.3713 42.3614 29.4766C42.6177 29.5819 42.8505 29.737 43.0464 29.9329C43.2423 30.1288 43.3974 30.3616 43.5027 30.6178C43.608 30.8741 43.6614 31.1487 43.6598 31.4258C43.6582 31.7028 43.6017 31.9768 43.4935 32.2318C43.3853 32.4869 43.2276 32.7179 43.0294 32.9116L39.2743 36.6674Z"
      fill="currentColor"
    />
  ),
});

const GuardianIcon = createIcon({
  displayName: "GuardianIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 4C6.567 4 5 5.567 5 7.5C5 9.433 6.567 11 8.5 11C10.433 11 12 9.433 12 7.5C12 5.567 10.433 4 8.5 4ZM17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7ZM8.5 13C5.69 13 3.23953 14.1403 2.01953 14.8203C1.38953 15.1803 1 15.8403 1 16.5703V19C1 19.552 1.448 20 2 20H8C8.552 20 9 19.552 9 19V17.1309C9 15.7109 9.77906 14.3799 11.0391 13.6699C11.1791 13.5899 11.3398 13.5099 11.5098 13.4199C10.5898 13.1699 9.57 13 8.5 13ZM17 14C14.858 14 12.9634 14.8861 12.0234 15.4141C11.3924 15.7701 11 16.4279 11 17.1309V19C11 19.552 11.448 20 12 20H22C22.552 20 23 19.552 23 19V17.1309C23 16.4279 22.6066 15.7701 21.9746 15.4141C21.0356 14.8861 19.142 14 17 14Z"
      fill="currentColor"
    />
  ),
});

const ImportantIcon = createIcon({
  displayName: "ImportantIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
      fill="currentColor"
    />
  ),
});

// Will Change after migration to default export
const icons = {
  CheckmarkIcon,
  CloseIcon,
  InfoIcon,
  ArrowRightIcon,
  ChevronRightIcon,
  ChevronLefttIcon,
  MoneyIcon,
  PlaneIcon,
  CheckmarkThickIcon,
  ConsultantIcon,
  BadgeCheckmarkIcon,
  SofaIcon,
  DoctorIcon,
  TrustPilotStarIcon,
  GavelIcon,
  EarthWithPlaneIcon,
  BanknotesIcon,
  LuggageIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedInIcon,
  CaretIcon,
  PlaneUpIcon,
  PlaneDownIcon,
  HamburgerMenuIcon,
  TrustPilotLogoIcon,
  ClockIcon,
  CrossedPlaneIcon,
  XIcon,
  PeopleIcon,
  EnvelopeIcon,
  CopyIcon,
  PlusIcon,
  MinusIcon,
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  DownloadIcon,
  SideMenuIcon,
  LinkIcon,
  HammerIcon,
  BlueInfoIcon,
  CircleIcon,
  GraphIcon,
  TableSortUpIcon,
  TableSortDownIcon,
  SearchIcon,
  PlaneWithClockIcon,
  WorldIcon,
  FoodIcon,
  CalendarIcon,
  CancelledFlightIcon,
  ArrowRightAltIcon,
  ImportantIcon,
  GuardianIcon,
};

export {
  CheckmarkIcon,
  CloseIcon,
  InfoIcon,
  ArrowRightIcon,
  ChevronRightIcon,
  ChevronLefttIcon,
  MoneyIcon,
  PlaneIcon,
  CheckmarkThickIcon,
  XThickIcon,
  ConsultantIcon,
  BadgeCheckmarkIcon,
  SofaIcon,
  DoctorIcon,
  TrustPilotStarIcon,
  GavelIcon,
  EarthWithPlaneIcon,
  BanknotesIcon,
  LuggageIcon,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  LinkedInIcon,
  CaretIcon,
  PlaneUpIcon,
  PlaneDownIcon,
  HamburgerMenuIcon,
  TrustPilotLogoIcon,
  ClockIcon,
  CrossedPlaneIcon,
  XIcon,
  PeopleIcon,
  EnvelopeIcon,
  CopyIcon,
  PlusIcon,
  MinusIcon,
  NumberOneIcon,
  NumberTwoIcon,
  NumberThreeIcon,
  DownloadIcon,
  SideMenuIcon,
  LinkIcon,
  HammerIcon,
  BlueInfoIcon,
  CircleIcon,
  GraphIcon,
  TableSortUpIcon,
  TableSortDownIcon,
  SearchIcon,
  icons,
  PlaneWithClockIcon,
  WorldIcon,
  FoodIcon,
  CalendarIcon,
  CancelledFlightIcon,
  ArrowRightAltIcon,
  ImportantIcon,
  GuardianIcon,
};

export type IconName = keyof typeof icons;
